import * as Icons from "lucide-react";
import { PageHero, CTABand } from "../components/sections";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { EnquiryForm } from "../components/EnquiryForm";
import { IMAGES } from "../data/site";

const OFFERINGS = [
  { icon: "Presentation", title: "Meetings & Conferences", desc: "Venue sourcing, AV, delegate management and seamless logistics for corporate meets of any scale." },
  { icon: "Trophy", title: "Incentive Travel", desc: "Reward your top performers with unforgettable domestic and international incentive trips." },
  { icon: "Users2", title: "Team Offsites", desc: "Energising team-building retreats, adventure days and leadership offsites." },
  { icon: "PartyPopper", title: "Corporate Events", desc: "Product launches, annual days, dealer meets and gala dinners, flawlessly executed." },
];

export default function Mice() {
  return (
    <div>
      <PageHero eyebrow="MICE & Corporate Events" title="Business travel, elevated" subtitle="Meetings, Incentives, Conferences & Events — managed end-to-end by a team that has been doing it for 35+ years." image={IMAGES.corporate} />

      <section className="ll-container ll-section">
        <Reveal className="max-w-3xl">
          <p className="eyebrow text-[#f7ad2d]">Your Corporate Travel Partner</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold mt-4 leading-tight">Every detail handled, so you can focus on business</h2>
          <p className="text-[#4A5D58] text-lg mt-6 leading-relaxed">From a 20-person board offsite to a 2000-delegate dealer conference, Life Line brings decades of relationships with hotels, transporters and venues across India and abroad — delivering flawless events on time and on budget.</p>
        </Reveal>

        <Stagger className="grid sm:grid-cols-2 gap-6 mt-14">
          {OFFERINGS.map((o) => {
            const C = Icons[o.icon] || Icons.Sparkles;
            return (
              <StaggerItem key={o.title}>
                <div className="ll-card p-8 h-full">
                  <div className="w-14 h-14 rounded-2xl bg-[#0A221C] flex items-center justify-center mb-5"><C size={24} className="text-[#4ef72d]" /></div>
                  <h3 className="font-display text-2xl font-bold">{o.title}</h3>
                  <p className="text-[#4A5D58] mt-3 leading-relaxed">{o.desc}</p>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </section>

      <section className="ll-container pb-24 grid md:grid-cols-2 gap-14 items-center">
        <Reveal>
          <p className="eyebrow text-[#f7ad2d]">Request a Proposal</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold mt-3 leading-tight">Plan your next corporate event</h2>
          <p className="text-[#4A5D58] text-lg mt-5">Tell us your objectives, group size and preferred dates. Our MICE desk will revert with a tailored proposal.</p>
        </Reveal>
        <Reveal delay={0.15}><div className="ll-card p-8"><EnquiryForm packageName="MICE & Corporate Event" /></div></Reveal>
      </section>

      <div className="pb-24"><CTABand /></div>
    </div>
  );
}
